import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_UpcomingVestingGrantsDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { type TableParamsType } from '../../types/common';

const useGetUpcomingPsuVestingList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_UpcomingVestingGrantsDto | undefined,
  unknown
> => {
  const { sorting, skipCount, maxResultCount, filter } = tableInfo;
  const upcomingPsuVestingList = useQuery(
    ['getUpcomingPsuVestingList', sorting, skipCount, maxResultCount, filter],
    async () => {
      return await handleRequest(
        PsuAwardService.getApiAwardApiAppPSUAwardUpcomingVestingGrants(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return upcomingPsuVestingList;
};

export default useGetUpcomingPsuVestingList;
